import { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { MdModeEdit } from "react-icons/md";
import RemoveModal from "./RemoveModal";

const FolderItem = ({
  folder,
  isActive,
  isRootFolder,
  showInModal,
  onFolderClick,
  onAddSubfolder,
  onEditSave,
  onRemoveClick,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const nameRef = useRef(null);

  const handleEditClick = (e) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  const handleSaveEdit = () => {
    const name = nameRef.current.value.trim();
    if (name) {
      onEditSave(folder.id, name);
      setIsEditing(false);
    }
  };

  const handleCancelEdit = (e) => {
    e.stopPropagation();
    setIsEditing(false);
  };

  return (
    <span
      onClick={() => !isEditing && onFolderClick(folder.id)}
      className={`list-group-link parent-list-group-link${isActive ? " active" : ""}${isEditing ? " editing" : ""}`}
    >
      {isEditing ? (
        <>
          <Form.Control
            type="text"
            defaultValue={folder.name}
            ref={nameRef}
            maxLength={30}
            autoFocus
            className="folder-edit-input"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSaveEdit();
              }
            }}
          />
          <span className="control-btns" onClick={(e) => e.stopPropagation()}>
            <Button variant="outline-info" size="sm" className="no-underline" onClick={handleSaveEdit}>
              Save
            </Button>
            <Button variant="outline-info" size="sm" className="ms-2 no-underline" onClick={handleCancelEdit}>
              X
            </Button>
          </span>
        </>
      ) : (
        <>
          <span className="folder-name">{folder.name}</span>
          <span className="control-btns">
            {isRootFolder && !showInModal && (
              <Button variant="outline-info" size="sm" onClick={onAddSubfolder}>
                <FiPlus size={12} />
              </Button>
            )}
            <Button
              variant="outline-info"
              size="sm"
              onClick={handleEditClick}
              className={`mx-2 ${showInModal ? "hidden" : ""}`}
            >
              <MdModeEdit />
            </Button>
            <span className={showInModal ? "hidden" : ""} onClick={(e) => e.stopPropagation()}>
              <RemoveModal handleOnRemoveClick={() => onRemoveClick(folder.id)} />
            </span>
          </span>
        </>
      )}
    </span>
  );
};

export default FolderItem;
